module.exports = __webpack_public_path__ + "img/role-icon.6e988b06.svg";